import React, { useState } from 'react';
import { GetStarted } from '@questlabs/react-sdk';
import SafeIcon from '../common/SafeIcon';

const NOTIFICATION_HISTORY = [
  { id: 1, candidate: 'Yaw Mensah', status: 'Shortlisted', date: 'Oct 25, 2023 10:30 AM', channel: 'Email/SMS' },
  { id: 2, candidate: 'Ama Serwaa', status: 'Interview Scheduled', date: 'Oct 24, 2023 02:15 PM', channel: 'Email' },
  { id: 3, candidate: 'Ekow Thompson', status: 'Rejected', date: 'Oct 23, 2023 09:00 AM', channel: 'Email' },
  { id: 4, candidate: 'Linda Ofori', status: 'Document Verification', date: 'Oct 22, 2023 11:45 AM', channel: 'SMS' },
];

const Notifications = () => {
  const [activeTab, setActiveTab] = useState('tracker');

  const styleConfig = {
    Form: {
      backgroundColor: '#FFFFFF',
      borderRadius: '4px',
      padding: '24px',
      boxShadow: '0 4px 18px 0 rgba(75,70,92,0.1)',
      border: '1px solid #f1f5f9'
    },
    Topbar: {
      borderBottom: '1px solid #f1f5f9',
      marginBottom: '20px',
      paddingBottom: '16px'
    },
    Heading: {
      color: '#11469A',
      fontSize: '20px',
      fontWeight: '700',
    },
    Description: {
      color: '#6b7280',
      fontSize: '14px',
      marginBottom: '24px'
    },
    Card: {
      backgroundColor: '#f8fafc',
      border: '1px solid #e2e8f0',
      borderRadius: '8px'
    },
    PrimaryButton: {
      backgroundColor: '#00AEEF',
      color: '#FFFFFF',
      borderRadius: '4px',
      fontWeight: '700',
      fontSize: '13px',
      textTransform: 'uppercase',
      letterSpacing: '0.1em',
      height: '48px',
      padding: '0 32px'
    },
    ProgressBar: {
      barColor: '#00AEEF',
      barParentColor: '#e2e8f0',
      ProgressText: {
        color: '#11469A',
        fontSize: '14px',
        fontWeight: '600'
      }
    }
  };

  return (
    <div className="space-y-6">
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4">
        <div>
          <h1 className="text-2xl font-bold text-gray-800">Application Status Notifications</h1>
          <p className="text-gray-500">Manage candidate communications and process tracking.</p>
        </div>
        <div className="flex gap-2">
          <button 
            onClick={() => setActiveTab('tracker')}
            className={`px-4 py-2 text-sm font-bold rounded-lg transition-all ${activeTab === 'tracker' ? 'bg-[#11469A] text-white shadow-md' : 'bg-white text-gray-600 hover:bg-gray-50'}`}
          >
            Process Tracker
          </button>
          <button 
            onClick={() => setActiveTab('history')}
            className={`px-4 py-2 text-sm font-bold rounded-lg transition-all ${activeTab === 'history' ? 'bg-[#11469A] text-white shadow-md' : 'bg-white text-gray-600 hover:bg-gray-50'}`}
          >
            Notification History
          </button>
        </div>
      </div>

      {activeTab === 'tracker' ? (
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
          <div className="lg:col-span-2">
            <div className="bg-white rounded-xl overflow-hidden shadow-sm border border-gray-100">
              <GetStarted 
                styleConfig={styleConfig}
                questId="application-status-quest"
                userId="admin-hr"
              />
            </div>
          </div>
          <div className="space-y-6">
            <div className="card p-6 border-l-4 border-l-[#00AEEF]">
              <h3 className="text-lg font-bold text-[#11469A] mb-4">Quick Alert</h3>
              <p className="text-sm text-gray-500 mb-6">Send an instant status update to the current active candidate.</p>
              <div className="space-y-4">
                <select className="w-full px-4 h-11 rounded border border-gray-200 text-sm focus:border-[#00AEEF] outline-none">
                  <option>Select Status...</option>
                  <option>Shortlisted</option>
                  <option>Interview Scheduled</option>
                  <option>Document Verification</option>
                  <option>Offered</option>
                </select>
                <button className="w-full py-3 bg-[#11469A] text-white rounded font-bold text-xs uppercase tracking-widest hover:bg-[#0d3678] transition-all">
                  Send Notification
                </button>
              </div>
            </div>
            
            <div className="card p-6 bg-gray-50 border-none">
              <h4 className="text-sm font-bold text-gray-700 mb-3 uppercase tracking-wider">Helpful Tip</h4>
              <p className="text-xs text-gray-500 leading-relaxed">
                Automated notifications are sent via email and SMS whenever a candidate's status is updated in the Applications module.
              </p>
            </div>
          </div>
        </div>
      ) : (
        <div className="card overflow-hidden border border-gray-100">
          <div className="overflow-x-auto">
            <table className="w-full text-left text-sm">
              <thead className="bg-gray-50 text-gray-400 font-semibold uppercase text-[11px] tracking-widest border-b border-gray-100">
                <tr>
                  <th className="px-6 py-4">CANDIDATE</th>
                  <th className="px-6 py-4">STATUS UPDATE</th>
                  <th className="px-6 py-4">CHANNELS</th>
                  <th className="px-6 py-4">TIMESTAMP</th>
                  <th className="px-6 py-4 text-right">DETAILS</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-100">
                {NOTIFICATION_HISTORY.map((log) => (
                  <tr key={log.id} className="hover:bg-gray-50/50 transition-colors">
                    <td className="px-6 py-4">
                      <div className="font-bold text-gray-800">{log.candidate}</div>
                    </td>
                    <td className="px-6 py-4">
                      <span className={`px-2 py-0.5 rounded text-[10px] font-bold uppercase tracking-wider ${
                        log.status === 'Rejected' ? 'bg-red-50 text-red-600' : 'bg-blue-50 text-blue-600'
                      }`}>
                        {log.status}
                      </span>
                    </td>
                    <td className="px-6 py-4 text-gray-500 font-medium">{log.channel}</td>
                    <td className="px-6 py-4 text-gray-400">{log.date}</td>
                    <td className="px-6 py-4 text-right">
                      <button className="p-2 text-gray-400 hover:text-[#11469A]">
                        <SafeIcon name="ExternalLink" size={16} />
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
};

export default Notifications;